// export const ZIO_CENTER_SERVER_HOST = process.env.REACT_APP_SERVER_PATH;
export const ZIO_CENTER_SERVER = process.env.REACT_APP_SERVER_PATH

export const WEBSITE_LOGIN = '/api/v1/cms/website/login'
export const ANNOUNCEMENT = '/api/v1/cms/announcement'
export const ANNOUNCEMENT_ACTIVE = '/api/v1/cms/announcement/active'
export const ANNOUNCEMENT_LIST = '/api/v1/cms/announcement/list'
export const ANNOUNCEMENT_LIST_ACTIVE = '/api/v1/cms/announcement/list/active'
export const ANNOUNCEMENT_CONTENT = '/api/v1/cms/announcement/content'
export const MARQUEE = '/api/v1/cms/marquee'
export const MARQUEE_ACTIVE = '/api/v1/cms/marquee/active'
export const MARQUEE_LIST = '/api/v1/cms/marquee/list/cms'
export const GAME_LIST = '/api/v1/cms/game/list'
export const GAME_OPTION_LIST = '/api/v1/cms/game/game_option/list'
export const GAME_REGISTER = '/api/v1/cms/game/register'
export const GAME_ELASTIC_MAX_BET = '/api/v1/cms/game/elastic_max_bet'
export const GAME_ELASTIC_MAX_BET_LIST = '/api/v1/cms/game/elastic_max_bet/list'
export const PLAYER = '/api/v1/cms/player'
export const PLAYER_LIST = '/api/v1/cms/player/list'
export const PLAYER_BLOCK = '/api/v1/cms/player/block'
export const PLAYER_UNBLOCK = '/api/v1/cms/player/unblock'
export const PLAYER_ALL_PLAYERS_MONEY = '/api/v1/cms/player/all_players_money'
export const PLAYER_LOGIN_HISTORY_LIST = '/api/v1/cms/player/login_history/list'
export const PLAYER_ONLINE_COUNT = '/api/v1/cms/game/player/count'
export const PLAYER_ONLINE_COUNT_EACH_GAME = '/api/v1/cms/game/player/count/each_game'
export const PLAYER_USER_ACTION_LOG = '/api/v1/cms/player/user_action_log'
export const BET_DETAIL = '/api/v1/cms/bet_detail'
export const BET_RECORD = '/api/v1/cms/bet_record'
export const BET_RECORD_LIST = '/api/v1/cms/bet_record/list'
export const BET_RECORD_LIST_BY_ROUND_ID = '/api/v1/cms/bet_record/list/round_id'
export const BET_RECORD_SUM_LIST_BY_GAME = '/api/v1/cms/bet_record/sum/list/game'
export const BET_RECORD_SUM_LIST_BY_DATE = '/api/v1/cms/bet_record/sum/list/date'
export const BET_RECORD_SUM_LIST_BY_PF_ACCOUNT = '/api/v1/cms/bet_record/sum/list/pf_account'
export const BET_RECORD_SUM_LIST_BY_GAME_ROUND = '/api/v1/cms/bet_record/sum/list/game_round'
export const BOT_RECORD_LIST_BY_GAME = '/api/v1/cms/bet_record/list/game/bot'
export const TRANSFER_RECORD_LIST = '/api/v1/cms/transfer_record/list'
export const PAYMENT_FLOW_RECORD_LIST = '/api/v1/cms/payment_flow_record/list'
export const SYSTEM_TIME = '/api/v1/cms/system/time'
export const SYSTEM_CLOSE_GAME = '/api/v1/cms/system/close/game'
export const SYSTEM_CLOSE_PLATFORM_GAME = '/api/v1/cms/system/close/pf_game'
export const SYSTEM_CLOSE_SERVER = '/api/v1/cms/system/close/server'
export const SYSTEM_CLOSE_CHECK = '/api/v1/cms/system/close/check'
export const SYSTEM_CMS_USER_ONLINE_LIST = '/api/v1/cms/system/cms_user_online/list'
export const USER = '/api/v1/cms/user'
export const USER_SELF = '/api/v1/cms/user/self'
export const USER_ACTIVE = '/api/v1/cms/user/active'
export const USER_LIST = '/api/v1/cms/user/list'
export const ROLE = '/api/v1/cms/role'
export const ROLE_LIST = '/api/v1/cms/role/list'
export const ROLE_CREATE_ROLE_USER_BOTH = '/api/v1/cms/role/create_role_user_both'
export const SUB_PLATFORM_LIST = '/api/v1/cms/platform/sub_platform/list'
export const SUB_PLATFORM_REGISTER = '/api/v1/cms/platform/sub_platform/register'
export const SUB_PLATFORM_REFRESH = '/api/v1/cms/platform/sub_platform/refresh'
export const JACKPOT = '/api/v1/cms/jackpot'
export const JACKPOT_RECORD_LIST = '/api/v1/cms/jackpot/record/list'
export const JACKPOT_DEPOSIT = '/api/v1/cms/jackpot/deposit'
export const JACKPOT_WITHDRAW = '/api/v1/cms/jackpot/withdraw'
export const RISKMGT_GAME_RISK_INFO_LIST = '/api/v1/cms/riskmgt/game_risk_info/list'
export const RISKMGT_GAME_RISK_INFO = '/api/v1/cms/riskmgt/game_risk_info'
export const RISKMGT_GAME_RISK_INFO_RTP = '/api/v1/cms/riskmgt/game_risk_info/oid'
export const RISKMGT_RTP_LEVEL_LIST = '/api/v1/cms/riskmgt/game_risk_info/rtp_level_list'
export const RISKMGT_RISK_RULE_LIST = '/api/v1/cms/riskmgt/risk_rule/list'
export const RISKMGT_RISK_RULE = '/api/v1/cms/riskmgt/risk_rule'
export const RISKMGT_COMPENSATION_LIST = '/api/v1/cms/riskmgt/compensation/list'
export const RISKMGT_COMPENSATION_PRIZE_LIST = '/api/v1/cms/riskmgt/compensation/prize_list'
export const RISKMGT_COMPENSATION = '/api/v1/cms/riskmgt/compensation'
export const RISKMGT_WATERPOOL_LIST = '/api/v1/cms/riskmgt/waterpool/list'
export const RISKMGT_WATERPOOL = '/api/v1/cms/riskmgt/waterpool'
export const RISKMGT_PLAYER_RISK_INFO_LIST = '/api/v1/cms/riskmgt/player_risk_info/list'
export const RISKMGT_PLAYER_RISK_INFO = '/api/v1/cms/riskmgt/player_risk_info'
export const RISKMGT_LOG_LIST = '/api/v1/cms/riskmgt/log/list'
export const EXCHANGE_CURRENCY_LIST = '/api/v1/cms/exchange_currency/list'
export const RETENTION_REPORTS = '/api/v1/cms/reports/retentions'
export const RED_PACKET = '/api/v1/cms/red_packet'
export const RED_PACKET_LIST = '/api/v1/cms/red_packet/event_list'
export const RED_PACKET_ADD = '/api/v1/cms/red_packet/add'
export const RED_PACKET_DETAIL = '/api/v1/cms/red_packet/detail'
export const RED_PACKET_STATUS = '/api/v1/cms/red_packet/status'
export const RED_PACKET_GACHA = '/api/v1/cms/red_packet/gacha'
export const DRAGON_TIGER_BOARD = '/api/v1/cms/dt_board'
export const DRAGON_TIGER_BOARD_LIST = '/api/v1/cms/dt_board/list'
export const DRAGON_TIGER_BOARD_DETAIL = '/api/v1/cms/dt_board/detail'
export const DRAGON_TIGER_BOARD_SEND_AWARD = '/api/v1/cms/dt_board/send_award'
export const DRAGON_TIGER_BOARD_AWARD_LIST = '/api/v1/cms/dt_board/awards'
export const PALYER_EVENT_AWARD_LIST = '/api/v1/cms/event/player/awards'
export const PROPRIETOR = '/api/v1/cms/proprietor'
export const PROPRIETOR_LIST = '/api/v1/cms/proprietor/list'
export const PROPRIETOR_RECONCILIATION_DATA_LIST = '/api/v1/cms/proprietor/reconciliation_data/list'
export const ONLINE_PLAYER_LIST = '/api/v1/cms/historical_record/online_player'
export const AGENT_LIST = '/api/v1/cms/platform/top_agent/list'
export const BET_RECORD_SUM_LIST_BY_REPORTGAME = '/api/v1/cms/bet_record/sum/list/report_game'
export const BET_RECORD_SUM_LIST_BY_REPORT_PF_ACCOUNT = '/api/v1/cms/bet_record/sum/list/report_pf_account'
export const GAME_PLATFORMS_LIST = '/api/v1/cms/game/platforms'
export const GAME_STATUS = '/api/v1/cms/game/status'
export const GAME_PLATFORMS_STATUS = '/api/v1/cms/game/platforms/status'
export const PLATFORM_CREATED = '/api/v1/cms/platform/sub_platform/add'
export const PLATFORM_EDIT = '/api/v1/cms/platform/sub_platform/edit'
export const GIVE_FREE_GAME = '/api/v1/cms/free_spin'
export const GIVE_FREE_GAME_LIST = '/api/v1/cms/free_spin/list'
export const GIVE_FREE_GAME_DETAIL = '/api/v1/cms/free_spin/detail'
export const GIVE_FREE_GAME_DETAIL_list = '/api/v1/cms/free_spin/detail/list'
export const GIVE_FREE_GAME_DETAIL_record = '/api/v1/cms/free_spin/detail/record_id'
export const GIVE_FREE_GAME_DETAIL_round = '/api/v1/cms/free_spin/detail/round_id'
export const GIVE_FREE_GAME_DETAIL_PRIZE = '/api/v1/cms/free_spin/list/platform_prize'
export const TRANSFER_RECORD_SUMMARY = '/api/v1/cms/transfer_record/summary'
export const PLATFROM_GAME_WATERPOOL = '/api/v1/cms/riskmgt/platfrom_game_waterpool'
export const PLATFROM_GAME_WATERPOOL_STATUS_LIST = '/api/v1/cms/riskmgt/platfrom_game_waterpool/status/list'
export const FAKEACCOUNT_RED_PACKET = '/api/v1/cms/red_packet/sock_puppet'
export const FAKEACCOUNT_RED_PACKET_MONEY = '/api/v1/cms/sock_puppet/red_packet/money'
export const FAKEACCOUNT_RED_PACKET_STAGE = '/api/v1/cms/red_packet/stage'
export const FAKEACCOUNT_DRAGON = '/api/v1/cms/sock_puppet/dragon'
export const FAKEACCOUNT_TIGER = '/api/v1/cms/sock_puppet/tiger'
export const SINGLE_WALLET = '/api/v1/cms/single_wallet/api' 
export const SINGLE_WALLET_REGISTER = '/api/v1/cms/single_wallet/api/register' 
export const SINGLE_WALLET_VALIDATE = '/api/v1/cms/single_wallet/api/validate' 
export const GAME_RANK = '/api/v1/cms/game_rank' 
export const GAME_RANK_RERANK = '/api/v1/cms/game_rank/rerank' 
export const RISKMGT_FEATURE_BUY_INFO_LIST = '/api/v1/cms/riskmgt/game_risk_info/list'
export const DOWNLOAD_RECORD_URL = '/api/v1/cms/bet_record/url'

export const EVENT_LIST_STATUS = '/api/v1/cms/event/status'
export const EVENT_LIST_FREE_SPIN_STATUS = '/api/v1/cms/free_spin/status'

export const UPLOAD_IMG = '/api/v1/cms/editor/upload' 
export const EVENT_GANE_LIST = '/api/v1/cms/event/game/list'

export const RECOMMENDATIONS_LATEST = '/api/v1/cms/recommendations/latest' 
export const RECOMMENDATIONS_LATEST_REFRESH = '/api/v1/cms/recommendations/latest/refresh' 
export const PLATFORM_RECOMMENDATIONS_LATEST = '/api/v1/cms/platform/recommendations/latest' 

export const RECOMMENDATIONS_TOP = '/api/v1/cms/recommendations/top' 
export const RECOMMENDATIONS_TOP_REFRESH = '/api/v1/cms/recommendations/top/refresh' 
export const PLATFORM_RECOMMENDATIONS_TOP = '/api/v1/cms/platform/recommendations/top' 
export const ACTIVITY_IMAGES = '/api/v1/cms/activity_images'
export const ACTIVITY_IMAGES_RANKS = '/api/v1/cms/activity_images/actived_ranks'
export const BET_RECORD_LIST_BY_GAME = '/api/v1/cms/player/bet_record/sum/list/game'

/** OTP相關 */
export const CHECK_OTP_ENABLE = '/api/v1/cms/otp/check/enable'
export const OTP_VALIDATE = '/api/v1/cms/otp/validate'
export const GET_OTP_QRCODE = '/api/v1/cms/otp/qr_code'
export const OTP_UNBIBDING = '/api/v1/cms/otp/disable'

export const EVENT_PRIZE_ADMIN = '/api/v1/cms/red_packet/event_list/admin'
export const EVENT_PRIZE_USER = '/api/v1/cms/red_packet/event_list/user'

export const IP_VERIFY = '/api/v1/cms/ping'
export const RESET_PASSWORD = '/api/v1/cms/user/reset_pwd'

export const OTP_SWITCH = '/api/v1/cms/otp/active'

export const EXCLUSIVE_GAME = '/api/v1/cms/game/exclusive'
export const EXCLUSIVE_PLATFORM = '/api/v1/cms/game/platform/exclusive'
export const EVENT_SYSTEM = '/api/v1/cms/event_system/url'
